"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const provider_name_styles_1 = require("./provider-name.styles");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const ProviderName = ({ provider }) => {
    const fullName = provider.name.full;
    const degrees = Array.isArray(provider.degrees) && provider.degrees.length
        ? provider.degrees.map(({ name }, index) => {
            const markup = (react_1.default.createElement("span", { key: name + index, itemProp: "hasCredential", itemScope: true, itemType: "https://schema.org/EducationalOccupationalCredential" },
                react_1.default.createElement("span", { itemProp: "name" }, name)));
            const isLast = index === provider.degrees.length - 1;
            if (isLast) {
                return markup;
            }
            return react_1.default.createElement(react_1.default.Fragment, null,
                markup,
                ", ");
        })
        : null;
    return (react_1.default.createElement(provider_name_styles_1.ProviderNameContainer, null,
        react_1.default.createElement("span", { itemProp: "name" }, fullName),
        degrees && react_1.default.createElement(react_1.default.Fragment, null,
            ", ",
            degrees)));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(ProviderName);
//# sourceMappingURL=provider-name.js.map